import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d59f16d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card bg-white p-5 mb-4" }
const _hoisted_2 = { class: "card bg-white p-5 mb-4" }
const _hoisted_3 = { class: "d-flex flex-row justify-content-between align-items-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrganizationCard = _resolveComponent("OrganizationCard")!
  const _component_translate = _resolveComponent("translate")!
  const _component_MessageList = _resolveComponent("MessageList")!
  const _component_Button = _resolveComponent("Button")!
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_TipTapTextArea = _resolveComponent("TipTapTextArea")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_RoomDetails = _resolveComponent("RoomDetails")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.offer?.organization)
      ? (_openBlock(), _createBlock(_component_OrganizationCard, {
          key: 0,
          class: "card bg-white p-5 mb-4",
          organization: _ctx.offer.organization
        }, null, 8, ["organization"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, [
        _createVNode(_component_translate, null, {
          default: _withCtx(() => [
            _createTextVNode("Nachrichten")
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_MessageList, { offer: _ctx.offer }, null, 8, ["offer"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", null, [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Dokumente")
            ]),
            _: 1
          })
        ]),
        (_ctx.projectStage === 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_Button, {
                class: "flex-shrink-0",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateRoomDialog = true))
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode("  "),
                  _createVNode(_component_translate, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Datenraum hinzufügen")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_Dialog, {
                header: _ctx.i18n.$gettext('Datenraum erstellen'),
                visible: _ctx.showCreateRoomDialog,
                "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showCreateRoomDialog) = $event)),
                onHide: _ctx.resetCreateRoomDialog,
                modal: ""
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: _ctx.i18n.$gettext('Abbrechen'),
                    icon: "pi pi-times",
                    class: "p-button-text",
                    onClick: _ctx.resetCreateRoomDialog
                  }, null, 8, ["label", "onClick"]),
                  _createVNode(_component_Button, {
                    label: _ctx.i18n.$gettext('Speichern'),
                    icon: "pi pi-check",
                    autofocus: "",
                    disabled: !_ctx.roomName,
                    onClick: _ctx.createRoom
                  }, null, 8, ["label", "disabled", "onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_AnimatedInput, {
                    class: "mb-4",
                    modelValue: _ctx.roomName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.roomName) = $event)),
                    "auto-resize": "",
                    label: _ctx.i18n.$gettext('Datenraum-Name')
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(_component_TipTapTextArea, {
                    ref: "editor",
                    type: "text",
                    placeholder: _ctx.i18n.$gettext('Beschreibung / Hinweis-Text zum Datenraum'),
                    modelValue: _ctx.roomDescription,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.roomDescription) = $event)),
                    modelModifiers: { lazy: true, trim: true },
                    required: ""
                  }, null, 8, ["placeholder", "modelValue"])
                ]),
                _: 1
              }, 8, ["header", "visible", "onHide"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizationSpecificRooms, (room) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "mb-4",
          key: 'o-room-' + room.id
        }, [
          _createVNode(_component_RoomDetails, {
            room: room,
            "project-id": _ctx.offer?.projectId
          }, null, 8, ["room", "project-id"])
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roomsByOfferId(_ctx.offer?.id), (room) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "mb-4",
          key: 'room-' + room.id
        }, [
          (_openBlock(), _createBlock(_component_RoomDetails, {
            room: room,
            "project-id": _ctx.offer?.projectId,
            key: 'room-' + room.id,
            disabled: ""
          }, null, 8, ["room", "project-id"]))
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.offer.lotOffers || []), (lotOffer, i) => {
        return (_openBlock(), _createElementBlock("div", null, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roomsByOfferId(lotOffer?.id), (room) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mb-4",
              key: 'room-' + room.id
            }, [
              (_openBlock(), _createBlock(_component_RoomDetails, {
                room: room,
                "project-id": _ctx.offer?.projectId,
                key: 'room-' + room.id,
                disabled: ""
              }, null, 8, ["room", "project-id"]))
            ]))
          }), 128))
        ]))
      }), 256))
    ])
  ]))
}